import { Component, inject } from '@angular/core'
import { NavigationStart, Router, RouterOutlet } from '@angular/router'
import { FooterComponent } from '@cr-driver/footer/footer.component'
import { StateHandler } from '@cr-driver/handler/state.handler'
import { HeaderComponent } from '@cr-driver/header/header.component'
import { TranslateModule } from '@ngx-translate/core'
import { PcStatusOverlayService } from '@shared/services/pc-status-overlay/pc-status-overlay.service'

import { PCStatusOverlayComponent } from '@shared/components/pc-status-overlay/pc-status-overlay.component'
import { BreadcrumbHandler } from './core/handler/breadcrumb.handler'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, HeaderComponent, FooterComponent, PCStatusOverlayComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'Charge Repay Service'

  private breadcrumbHandler = inject(BreadcrumbHandler)
  public overlayService = inject(PcStatusOverlayService)

  constructor(
    private router: Router,
    private stateHandler: StateHandler
  ) {
    this.breadcrumbHandler.initialize()

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const firstUrl = event.url
        this.stateHandler.setOrigin(firstUrl)
      }
    })
  }
}
